<template>
	<div class="indexBanner">
		<!-- <div class="box" @mouseenter="enter" @mouseleave="likai">
			<img class="hidden-xs-only" alt="" @transitionend="end" v-for="(item,index) in data" :src="item.picUrl" :style="{opacity:index==num?1:0}" :key='index'>
			<img class="hidden-sm-and-up" alt="" @transitionend="end" v-for="(item,index) in data1" :src="item.picUrl" :style="{opacity:index==num?1:0}" :key='"yd"+index'>
			<ul class="mark hidden-xs-only">
				<li v-for="x in data.length" :class="{con:x-1==num}" @click="num=x-1" :key='x'></li>
			</ul>
			<div @click="next" class="xia">></div>
			<div @click="prev" class="shang"><</div>
		</div> -->
    <el-carousel v-if="data.length" height="500px" :interval="7000">
      <el-carousel-item v-for="item in data" :key="item.picUrl">
        <img :src="item.picUrl" alt="" />
      </el-carousel-item>
    </el-carousel>
	</div>
</template>
<script>
export default {
    name:'indexBanner',
    data(){
      return{
        num: 0,
        timer:null,
        flag:true,
        data:[
          {picUrl: require('@/assets/images/ban01.jpeg')},
          {picUrl: require('@/assets/images/ban02.jpeg')},
          {picUrl: require('@/assets/images/ban03.jpeg')}
        ],
        data1:[
          {picUrl:'banner1M.png'},
          {picUrl:'banner2M.png'},
          {picUrl:'banner3M.png'},
        ],
      }
    },
		created() {
			this.timer = setInterval(this.next.bind(this), 5000)
		},
    methods: {
			next:function(){
					if(this.flag){
							this.flag=false;
							this.num++;
							if(this.num>this.data.length-1){
									this.num=0
							}
					}
			},
			prev:function(){
					this.num--;
					if(this.num<0){
							this.num=this.data.length-1
					}
			},
			enter:function(){
					clearInterval(this.timer)
			},
			likai:function(){
					this.timer = setInterval(this.next.bind(this), 5000)
			},
			end:function(){
					this.flag=true
			}
    }
}
</script>
<style scoped>
.indexBanner {
  height: 500px;
  margin-top: 70px;
}

.indexBanner img {
  width: 100%;
  height: 100%;
  display: block;
}


.indexBanner /deep/ .el-carousel__button {
  background: #ccc;
}

.indexBanner /deep/ .el-carousel__item.is-animating {
  transition: opacity .2s ease-in-out !important;
}

.indexBanner .box {
  width: 100%;
  /* position: fixed; */
  position: relative;
  height: 500px;
  overflow: hidden;
  /* margin: auto; */
  /* top: 110px; */
}

.indexBanner .box img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: all .5s;
}

.indexBanner .mark {
  position: absolute;
  bottom: 35px;
  left: 50%;
  transform: translate(-50%, 0);
}

.indexBanner .mark li {
  list-style: none;
  width: 60px;
  height: 5px;
  border-radius: 5px;
  background-color: #fff;
  opacity: 0.6;
  float: left;
  margin: 0 5px;
  cursor: pointer;
}

.indexBanner .shang, .indexBanner .xia {
  position: absolute;
  width: 55px;
  height: 55px;
  line-height: 55px;
  font-size: 20px;
  text-align: center;
  top: 50%;
  margin-top: -26px;
  background: #2e76cb;
  cursor: pointer;
  color: aliceblue;
  border-radius: 50%;
  transition: all 1s;
}

.indexBanner .shang {
  left: 60px;
  opacity: 0;
}

.indexBanner .xia {
  right: 60px;
  opacity: 0;
}

.indexBanner .box:hover .shang {
  opacity: 1;
  transition: all 1s;
}

.indexBanner .box:hover .xia {
  opacity: 1;
  transition: all 1s;
}

.indexBanner .mark .con {
  opacity: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/header-banner/index.vue